module.exports = __webpack_public_path__ + "static/media/openIcon.766ab20a.svg";